import styled from "styled-components";
import logoWhite from "../../../Assets/icon/logo_ba_wh.png";
import logoFont from "../../../Assets/icon/logo_ba_font_01.png";

export const Page = styled.div`
    display: flex; min-height: 100vh; font-family: Mulish; background: #FFFFFF;
`;
export const Left = styled.div`
    flex: 1; position: relative; overflow: hidden;
    background: linear-gradient(160deg, #2F6BF0, #1E4FC0);
    color: #FFFFFF; padding: 44px 52px; display: flex; flex-direction: column;
    @media (max-width: 860px) { display: none; }
    &::before {
        content: ""; position: absolute; inset: 0; pointer-events: none; opacity: 0.55;
        background-image: radial-gradient(circle, rgba(255,255,255,0.18) 1.4px, transparent 1.6px);
        background-size: 22px 22px;
    }
`;
export const HandMark = styled.div`
    width: 116px; height: 90px; margin-bottom: 26px; z-index: 1;
    background-image: url(${logoWhite});
    background-repeat: no-repeat; background-size: auto 90px; background-position: left center;
`;
export const LmRow = styled.div`display: flex; align-items: center; gap: 16px; z-index: 1;`;
export const LmBadge = styled.div`
    width: 78px; height: 78px; border-radius: 14px; background: rgba(255,255,255,0.16);
    border: 1px solid rgba(255,255,255,0.22);
    display: flex; align-items: center; justify-content: center;
    font-weight: 800; font-size: 1.5rem; letter-spacing: 1px;
`;
export const LmText = styled.div`
    font-weight: 800; font-size: 1.25rem; line-height: 1.15;
    span { display: block; font-weight: 500; opacity: 0.82; font-size: 0.92rem; }
`;
export const Illustration = styled.div`
    position: relative; flex: 1; margin: 30px 0; z-index: 1; min-height: 300px;
`;
export const Bubble = styled.div`
    position: absolute; border-radius: 18px; padding: 20px 22px;
    background: linear-gradient(180deg, rgba(255,255,255,0.30), rgba(255,255,255,0.16));
    border: 1px solid rgba(255,255,255,0.18); box-shadow: 0 10px 30px rgba(0,0,0,0.10);
    display: flex; flex-direction: column; gap: 11px;
    ${(p) => p.$tail && `
        &::after { content: ""; position: absolute; left: 20px; bottom: -12px;
            border-width: 14px 14px 0 0; border-style: solid;
            border-color: rgba(255,255,255,0.24) transparent transparent transparent; }
    `}
`;
export const Line = styled.div`
    height: 9px; border-radius: 6px; width: ${(p) => p.$w || "100%"};
    background: ${(p) => p.$strong ? "rgba(255,255,255,0.55)" : "rgba(148,163,184,0.6)"};
`;
export const Avatar = styled.div`
    position: absolute; width: ${(p) => p.$size || 52}px; height: ${(p) => p.$size || 52}px;
    border-radius: 50%; background: ${(p) => p.$color}; color: #FFFFFF;
    display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 0.82rem;
    box-shadow: 0 6px 16px rgba(0,0,0,0.18);
`;
export const Pitch = styled.div`
    z-index: 1;
    h2 { font-size: 1.15rem; margin: 0 0 6px; }
    p { margin: 0; opacity: 0.85; font-size: 0.9rem; }
`;
export const Footer = styled.div`margin-top: 26px; font-size: 0.78rem; opacity: 0.8; z-index: 1;`;

export const Right = styled.div`
    flex: 1; display: flex; align-items: center; justify-content: center; padding: 40px 72px;
`;
export const Form = styled.div`width: 100%; max-width: 560px;`;
export const Logo = styled.div`
    width: 112px; height: 74px; margin-bottom: 22px;
    background-image: url(${logoFont});
    background-repeat: no-repeat; background-size: 112px auto; background-position: left top;
`;
export const Title = styled.h1`font-size: 1.9rem; font-weight: 800; color: #14181F; margin: 0 0 6px; line-height: 1.15;`;
export const Sub = styled.p`color: #8A94A6; font-size: 0.9rem; margin: 0 0 28px;`;
export const Label = styled.label`display: block; font-size: 0.82rem; font-weight: 700; color: #2B3240; margin: 16px 0 7px;`;
export const Input = styled.input`
    width: 100%; box-sizing: border-box; border: 1px solid ${(p) => (p.$err ? "#EF4444" : "#D8DEE9")};
    border-radius: 8px; padding: 12px 14px; font-family: Mulish; font-size: 0.92rem; color: #2B3240;
    &:focus { outline: none; border-color: #2F80ED; }
`;
export const KeyWrap = styled.div`position: relative;`;
export const Eye = styled.button`
    position: absolute; right: 10px; top: 50%; transform: translateY(-50%);
    border: none; background: transparent; color: #8A94A6; cursor: pointer; font-size: 1.1rem; display: flex;
`;
export const FieldErr = styled.span`display: block; color: #EF4444; font-size: 0.75rem; margin-top: 6px;`;
export const RowBetween = styled.div`display: flex; align-items: center; justify-content: space-between; margin: 16px 0 24px;`;
export const Check = styled.label`display: flex; align-items: center; gap: 7px; font-size: 0.82rem; color: #2B3240; cursor: pointer;`;
export const ForgotLink = styled.button`border: none; background: transparent; color: #2F80ED; font-weight: 700; font-size: 0.82rem; cursor: pointer;`;
export const Submit = styled.button`
    width: 100%; border: none; background: #2F80ED; color: #FFF; font-family: Mulish; font-weight: 800;
    font-size: 0.95rem; padding: 13px; border-radius: 8px; cursor: pointer; letter-spacing: 0.5px;
    &:disabled { opacity: 0.6; cursor: not-allowed; }
`;
export const Toast = styled.div`
    margin-bottom: 18px; padding: 10px 14px; border-radius: 8px; background: #FFF7E6;
    border: 1px solid #FFE1A8; color: #8A6D3B; font-size: 0.82rem; line-height: 1.4;
`;
export const SuccessBox = styled.div`
    width: 100%; max-width: 360px; text-align: center;
    h1 { font-size: 1.4rem; color: #1F7A44; margin: 0 0 10px; }
    p { color: #6B7280; font-size: 0.9rem; }
`;
